import PropTypes from 'prop-types'
import React, { useEffect } from 'react'
import { CONTRIBUTOR_TYPES } from '../../constants/CustomerConstants'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { fetchUsers, selectUsers } from '../../../../admin/users/UsersSlice'
import { Avatar, Stack } from '@mui/material'
import PersonIcon from '@mui/icons-material/Person'

const ContributorIcon = ({
    contributor = {},
    stacked = false,
    hideRole = false,
}) => {
    const dispatch = useDispatch()
    const users = useSelector(selectUsers, shallowEqual)

    useEffect(() => {
        if (!users.length) {
            dispatch(fetchUsers())
        }
    }, [dispatch, users])

    const picture = contributor?.login ? users.find((u) => u.login === contributor?.login)?.picture : undefined
    const roleImg = !hideRole && contributor.typeContributor && CONTRIBUTOR_TYPES.find((t) => t.id === contributor.typeContributor)?.img

    const userImg = picture ? (
        <img src={picture} alt='' width='100%' height='auto' style={{ borderRadius: '15%' }} />
    ) : (
        <Avatar sx={{ width: '100%', height: 'auto' }}><PersonIcon sx={{ width: '100%', height: 'auto' }} /></Avatar>
    )

    // Mode empilé : image utilisateur puis logo du rôle en dessous (au lieu d'un badge superposé).
    if (stacked) {
        return (
            <Stack alignItems='center' spacing={0.5}>
                {userImg}
                {roleImg && (
                    <img
                        src={roleImg}
                        alt=''
                        style={{
                            width: '50%',
                            height: 'auto',
                            borderRadius: '50%',
                            border: '2px solid black',
                            backgroundColor: 'white',
                        }}
                    />
                )}
            </Stack>
        )
    }

    return (
        <div style={{ position: 'relative', width: '100%' }}>
            {userImg}
            {roleImg && (
                <img
                    src={roleImg}
                    alt=''
                    style={{
                        position: 'absolute',
                        bottom: '5px',
                        right: '5px',
                        width: '35%',
                        height: '35%',
                        borderRadius: '50%',
                        border: '2px solid black',
                        backgroundColor: 'white',
                        zIndex: 1,
                    }}
                />
            )}
        </div>
    )
}

ContributorIcon.propTypes = {
    contributor: PropTypes.shape({
        typeContributor: PropTypes.string,
        login: PropTypes.string,
    }),
    stacked: PropTypes.bool,
    hideRole: PropTypes.bool,
}

export default ContributorIcon
